import { BmFundActualAnalytics } from "../../../pojo/bm-classes";
import { BmAnalyticsCard } from "../../../pojo/bm-analytics-classes";
import { FpValueService } from "../../../../../../core/component/pojo/fp-modify-value.service";

export class BmCardsCalcService {

  /**
   * Calculate analytics cards data from actual fund data and budget data from model (table)
   *
   * @param budgetData - The budget modeled data from table
   * @returns Array of 6 analytics cards with calculated values
   */
  static calculateCards(budgetData: BmFundActualAnalytics): BmAnalyticsCard[] {
    return [
      new BmAnalyticsCard('Capital Required', FpValueService.modify(budgetData.capRequired)),
      new BmAnalyticsCard('Investment', FpValueService.modify(budgetData.investment)),
      new BmAnalyticsCard('Total Expenses', FpValueService.modify(budgetData.totalExp)),
      new BmAnalyticsCard('Management Fees', FpValueService.modify(budgetData.mgmFee)),
      new BmAnalyticsCard('Operating Expenses', FpValueService.modify(budgetData.opExp)),
      new BmAnalyticsCard('Organizational Expenses', FpValueService.modify(budgetData.orgExp)),
    ];
  }
}
